/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

import '../icon';
import '../tag-button';

import './checkbox.css';
import './checkbox_theme_alfa-on-color.css';
import './checkbox_theme_alfa-on-white.css';

export { default } from './checkbox';
